import React from 'react';
import ModalComponent from '@componentes/modal/modal.component';
import { Col, Row, Button, Badge } from 'reactstrap';
import ButtonFloating from '@componentes/button/button-floating.component';
import * as acessos from '../../../../acessos.const.util';
import ListaLaminasContainer from '../../../../app/common/tabs/listaLaminas/lista-laminas.container';
import AutorizacaoLaudarContainer from '../../../../app/common/autorizacaoLaudar/autorizacao-laudar.container';
import CancelamentoComponent from '@componentes/cancelamento/cancelamento.component';
import ConfirmarCancelamento from '../../../../componentes/cancelamento/confirmacao.component';
import HistoricoLaudoContainer from '../macroscopia/tabs/historicolaudo/historico-laudo.container';
import AnexoContainer from '@common/tabs/anexo/anexo.container';
import AutoTextoContainer from '@common/tabs/autotexto/autotexto.container';
import LaudosAnterioresContainer from '@common/tabs/anteriores/laudos-anteriores.container';
import IntlMessage from '../../../../helpers/intlMessage';
import ModalEncaminhar from '@common/modalEncaminhar/modalEncaminhar';

const CishPage = (props) => {
  return (
    <div>
      <ModalEncaminhar
        toggleModalEncaminhar={props.toggleModalEncaminhar}
        type={props.type}
        showModalEncaminhar={props.showModalEncaminhar}
        titulo={'Encaminhar'}
        mensagem={'Encaminhar'}
        confirmar={props.confirmar}
        laudo={props.laudo}
        commonActions={props.commonActions}
      />
      <ConfirmarCancelamento
        isOpen={props.modalIsOpen}
        toggle={props.toggleModalConfirmarCancelamento}
        shoModalJustificativa={props.showModalConfirmacaoCancelamento}
      />
      <CancelamentoComponent
        isOpen={props.showModalCancelamento}
        toggle={props.toggleModalCancelamento}
        setJustificativa={props.setJustificativa}
        justificativaCancelar={props.justificativaCancelar}
        cancelarEtapa={props.cancelarEtapas}
      />

      <ModalComponent
        size={props.modalSize}
        visivel={props.modalVisivel}
        cancela={props.closeModal}
        titulo={props.modalTitulo}
      >
        {props.modalConteudo}
      </ModalComponent>
      {props.modalAutorizacaoLaudar && (
        <AutorizacaoLaudarContainer
          fecharTela={props.fecharModalAutorizacao}
          callback={props.callbackAutorizar}
        />
      )}
      {props.detalhes !== undefined && (
        <Col className='paddingZero'>
          <div style={{ height: '100%' }} className='detalhes-cish-container'>
            <div className='inner-menu-container'>
              <Row>
                {props.acessoPermitido(props.usuario, acessos.AutoTexto) &&
                  !props.exameFinalizado &&
                  !props.cishFinalizada && (
                    <Col>
                      <Button
                        className={
                          props.visibilidadeAutotexto
                            ? 'mv-tab-ativo'
                            : undefined
                        }
                        onClick={() =>
                          props.alterarVisibilidadeAbas('visibilidadeAutotexto')
                        }
                        color='link'
                        title='CTRL+ALT+A'
                      >
                        <IntlMessage id="dashboards.examDetails.autoText" />
                      </Button>
                    </Col>
                  )}
                {props.acessoPermitido(props.usuario, acessos.Anexo) && (
                  <Col>
                    <Button
                      color='link'
                      className={
                        props.visibilidadeListagemAnexo
                          ? 'mv-tab-ativo'
                          : undefined
                      }
                      onClick={() =>
                        props.alterarVisibilidadeAbas(
                          'visibilidadeListagemAnexo'
                        )
                      }
                    >
                      <IntlMessage id="dashboards.examDetails.attachments" />
                    </Button>
                  </Col>
                )}

                {props.acessoPermitido(
                  props.usuario,
                  acessos.LaudosAnteriores
                ) && (
                    <Col>
                      <Button
                        className={`${props.totalExamesAbertos > 0
                            ? 'alerta-exame-aberto'
                            : props.visibilidadeLaudosAnteriores
                              ? 'mv-tab-ativo'
                              : props.visibilidadeLaudosAnteriores &&
                                props.totalExamesAbertos
                                ? 'mv-tab-ativo alerta-exame-aberto'
                                : ''
                          }`}
                        onClick={() =>
                          props.alterarVisibilidadeAbas(
                            'visibilidadeLaudosAnteriores'
                          )
                        }
                        color='link'
                        title='CTRL+ALT+T'
                      >
                        <IntlMessage id="dashboards.examDetails.previousReports" />
                        <Badge className='tabs-total-itens'>
                          {props.quantidadeLaudosAnteriores}
                        </Badge>
                      </Button>
                    </Col>
                  )}
                {props.acessoPermitido(
                  props.usuario,
                  acessos.HistoricoLaudo
                ) && (
                    <Col>
                      <Button
                        className={
                          props.visibilidadeHistoricoLaudo
                            ? 'mv-tab-ativo'
                            : undefined
                        }
                        onClick={() =>
                          props.alterarVisibilidadeAbas(
                            'visibilidadeHistoricoLaudo'
                          )
                        }
                        color='link'
                        title='CTRL+ALT+H'
                      >
                        <IntlMessage id="dashboards.examDetails.reportHistory" />
                      </Button>
                    </Col>
                  )}
                {props.acessoPermitido(props.usuario, acessos.ListaLaminas) &&
                  !props.exameFinalizado &&
                  !props.cishFinalizada && (
                    <Col>
                      <Button
                        color='link'
                        className={
                          props.visibilidadeListaLaminas
                            ? 'mv-tab-ativo'
                            : undefined
                        }
                        onClick={() =>
                          props.alterarVisibilidadeAbas(
                            'visibilidadeListaLaminas'
                          )
                        }
                      >
                        <IntlMessage id="dashboards.examDetails.bladeList" />
                      </Button>
                    </Col>
                  )}
                <Col>
                  <Button
                    onClick={props.alterarFullscreen}
                    color='link'
                    title='CTRL+ALT+F10'
                  >
                    <i
                      className={
                        window.document.fullscreen
                          ? 'fas fa-compress'
                          : 'fas fa-expand'
                      }
                    ></i>
                  </Button>
                </Col>
              </Row>
            </div>
            <Row className='mv-tabs-container'>
              {props.visibilidadeListaLaminas && (
                <Col
                  style={{
                    paddingLeft: '15px',
                    minWidth: '0%',
                    maxWidth: '30%'
                  }}
                >
                  <ListaLaminasContainer altura={props.altura} />
                </Col>
              )}

              {props.visibilidadeLaudosAnteriores &&
                props.acessoPermitido(
                  props.usuario,
                  acessos.LaudosAnteriores
                ) && (
                  <Col
                    style={{
                      paddingLeft: '15px',
                      minWidth: '0%',
                      maxWidth: '30%'
                    }}
                  >
                    <LaudosAnterioresContainer altura={props.altura} />
                  </Col>
                )}
              {props.visibilidadeAutotexto &&
                props.acessoPermitido(props.usuario, acessos.AutoTexto) && (
                  <Col
                    style={{
                      paddingLeft: '15px',
                      minWidth: '0%',
                      maxWidth: '30%'
                    }}
                  >
                    <AutoTextoContainer altura={props.altura} />
                  </Col>
                )}
              {props.visibilidadeListagemAnexo &&
                props.acessoPermitido(props.usuario, acessos.Anexo) && (
                  <Col
                    style={{
                      paddingLeft: '15px',
                      minWidth: '0%',
                      maxWidth: '30%'
                    }}
                  >
                    <AnexoContainer altura={props.altura} />
                  </Col>
                )}

              {props.visibilidadeHistoricoLaudo &&
                props.acessoPermitido(
                  props.usuario,
                  acessos.HistoricoLaudo
                ) && (
                  <Col
                    style={{
                      paddingLeft: '15px',
                      minWidth: '0%',
                      maxWidth: '30%'
                    }}
                  >
                    <HistoricoLaudoContainer altura={props.altura} />
                  </Col>
                )}
              <Col
                style={{
                  paddingLeft: '0px',
                  minWidth: '70%',
                  maxWidth: '100%'
                }}
              >
                <div
                  id='container-editor-etapa'
                  style={{ height: '100%' }}
                ></div>
              </Col>
            </Row>

            <ButtonFloating actions={props.construirBotoes} />
          </div>
        </Col>
      )}
    </div>
  );
};
export default CishPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/cish/cish.page.js